import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable(
   {
    providedIn: 'root'
    }
)
export class ToastrMessagesService {

    constructor(private toastr: ToastrService) { }

    showSuccessMessage(text: string, title?: string) {
        let header = title ? title : 'Successo!'
        this.toastr.success(text, header)
    }


    showWarnMessage(text: string, title?: string) {
        let header = title ? title : 'Avviso!'
        this.toastr.warning(text, header)
    }

    showErrorMessage(text: string, title?: string) {
        let header = title ? title : 'Errore!'
        this.toastr.error(text, header)
    }
}